import clsx from 'clsx'
import React, { useState } from 'react'

export default function Disclaimer(props) {
  const { enableDisclaimer, disclaimerText, onClose, onSubmit } = props

  const [checked, setChecked] = useState(false)

  const handleSubmit = () => {
    if (!checked) return

    onSubmit()
  }

  if (!enableDisclaimer) return

  return (
    <>
      <div className="disclaimer-container">
        <div className="disclaimer-body dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-h2">disclaimer</div>
          <div className="dome-p2 disclaimer-text">{disclaimerText}</div>
          <input
            id="toc-checkbox"
            type="checkbox"
            style={{ accentColor: '#4A4A4A' }}
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <label htmlFor="toc-checkbox" className="dome-p2 dome-cursor-pointer" style={{ color: '#666' }}>
            By checking this box, you are confirming you have read + agree to the terms and conditions above.
          </label>
        </div>
        <div className="disclaimer-footer dome-d-flex dome-justify-between">
          <button className="dome-btn dome-btn-link dome-btn-link-cancel" onClick={onClose}>
            cancel
          </button>
          <button
            className={clsx('dome-btn dome-btn-base', checked ? 'dome-btn-dark-green' : 'dome-btn-disabled')}
            onClick={handleSubmit}
            disabled={!checked}
          >
            continue
          </button>
        </div>
      </div>
    </>
  )
}
